import { render, staticRenderFns } from "./SystemMessageDisplay.vue?vue&type=template&id=14c01aa1&scoped=true&"
import script from "./SystemMessageDisplay.vue?vue&type=script&lang=js&"
export * from "./SystemMessageDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c01aa1",
  null
  
)

export default component.exports